import { render, staticRenderFns } from "./APList.vue?vue&type=template&id=ca1bfaa4"
import script from "./APList.vue?vue&type=script&lang=js"
export * from "./APList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports